<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2026-01-08 10:09:32
 * @Description:
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="absolute step-list">
    <div class="step-list__header">
      <span class="text-color-white  step-list__title">步骤列表</span>
      <el-button
        type="primary"
        style="margin-left: 128px;"
        size="small"
        @click="operate('collapse')"
        >全部收起</el-button
      >
      <el-button type="primary" class="ml-20px" size="small" @click="operate('expand')"
        >全部展开</el-button
      >
    </div>
    <el-card shadow="never" class="mt-10px step-list__content">
      <el-collapse ref="dragCollapse" :key="dragKey" v-model="openStepList">
        <el-collapse-item
          v-for="(item, index) in stepList"
          :key="item.nodeName"
          :name="item.nodeName"
        >
          <template slot="title">
            <div
              class="flex justify-between w-100  mr-10"
              :class="item.nodeName === activeStep ? 'active-step__title' : ''"
              @click.stop="handleCollapseChange(item)"
            >
              <div>{{ index + 1 }}: {{ item.nodeName }}</div>
              <el-tooltip content="拖拽" placement="top" effect="dark" :open-delay="1000">
                <!-- content to trigger tooltip here -->
                <div
                  class="iconfont el-icon-s-operation handle text-white"
                  style="display: flex;align-items: center;justify-content: center;"
                ></div>
              </el-tooltip>
            </div>
          </template>
          <el-form
            :model="item"
            :ref="`stepForm${item.id}`"
            :rules="stepFormRules"
            label-width="80px"
            :inline="false"
            size="small"
            :label-position="labelPosition"
          >
            <el-form-item label="步骤名称">
              <el-input v-model="item.name" placeholder="单行输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="拆卸说明">
              <el-input
                v-model="item.disAssembleyRemark"
                type="textarea"
                placeholder="单行输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="组装说明">
              <el-input
                v-model="item.assembleyRemark"
                type="textarea"
                placeholder="单行输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="拆卸条件">
              <el-select
                v-model="item.disAssembleyCondition"
                placeholder="步骤对象"
                clearable
                filterable
                class="w-full"
                :popper-append-to-body="false"
                popper-class="document_select-popper"
              >
                <el-option
                  v-for="item in conditionOption"
                  :key="item.nodeName"
                  :label="item.nodeName"
                  :value="item.nodeName"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="组装条件">
              <el-select
                v-model="item.assembleyCondition"
                placeholder="步骤对象"
                clearable
                filterable
                popper-class="document_select-popper"
                class="w-full"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in conditionOption"
                  :key="item.nodeName"
                  :label="item.nodeName"
                  :value="item.nodeName"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="拆卸方向">
              <el-select
                v-model="item.disAssembleyDiretionType"
                placeholder="拆卸方向"
                clearable
                filterable
                class="w-full"
                popper-class="document_select-popper"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in disAssembleyDiretionTypeOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="移动距离">
              <el-input v-model="item.moveDistance" placeholder="移动距离,单位是米" clearable>
                <span slot="suffix">m</span>
              </el-input>
            </el-form-item>
            <el-form-item label="移动速度">
              <el-input v-model="item.speed" placeholder="移动速度,单位是m/s" clearable>
                <span slot="suffix">m/s</span>
              </el-input>
            </el-form-item>
            <el-form-item label="考核分值">
              <el-input v-model="item.grade" placeholder="考核分值,范围0-100" clearable></el-input>
            </el-form-item>
            <el-form-item label="目标位置">
              <el-row :gutter="5" class="input-list">
                <el-col :span="7" :offset="0" v-for="inputItem in 3" :key="inputItem">
                  <el-tooltip
                    :content="String(item.targetLocation[inputItem - 1])"
                    placement="top"
                    effect="dark"
                  >
                    <!-- content to trigger tooltip here -->
                    <el-input
                      v-model="item.targetLocation[inputItem - 1]"
                      placeholder="位置"
                      @change="setNodeListPosition([item])"
                      size="small"
                    ></el-input>
                  </el-tooltip>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-collapse>
    </el-card>
    <el-row :gutter="20" class="mt-5px" style="margin-left: 10px;">
      <el-col :span="8" :offset="0" class="tc">
        <el-button type="primary" class="w-90px" @click="stepOperate('add')">新 增</el-button>
      </el-col>
      <el-col :span="8" :offset="0" class="tc">
        <el-button type="primary" class="w-90px" @click="stepOperate('insert')">插 入</el-button>
      </el-col>
      <el-col :span="8" :offset="0" class="tc">
        <el-button type="primary" class="w-90px" @click="stepOperate('delete')">删 除</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mt-5px" style="margin-left: 10px;">
      <el-col :span="8" :offset="0" class="tc">
        <el-button type="primary" class="w-90px" @click="stepOperate('save')">保 存</el-button>
      </el-col>
      <el-col :span="8" :offset="0" class="tc">
        <el-button type="primary" class="w-90px" @click="stepOperate('import')">导 入</el-button>
      </el-col>
      <el-col :span="8" :offset="0" class="tc">
        <el-button type="primary" class="w-90px" @click="stepOperate('export')">导 出</el-button>
      </el-col>
    </el-row>
    <upload-excel-dialog
      @refreshList="getSchemeDetail"
      v-if="uploadExcelProps.visible"
      :uploadExcelProps="uploadExcelProps"
      :modalAppendToBody="false"
      customClass="training-dialog"
    ></upload-excel-dialog>
  </div>
</template>

<script>
import FnMixins from '@/assets/js/fnMixins'
import { EquipDisAssembleySolutionApi } from '@wiz-api/equipment-assembly-trainning'
import Sortable from '@/assets/js/Sortable.js'

const equipDisAssembleySolution = new EquipDisAssembleySolutionApi()

const UploadExcelDialog = () => {
  return import('./UploadExcel')
}
export default {
  mixins: [FnMixins],
  components: {
    UploadExcelDialog,
  },
  props: {
    player: {
      type: Object,
      default: null,
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    loadSceneEnd: {
      type: Boolean,
      default: false,
    },
    currentSelectModel: {
      type: Number,
      default: null,
    },
    // 方案列表
    steps: {
      type: Array,
      default: () => {
        return []
      },
    },
    schemeId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showUploadExcelDialog: false,
      dragKey: Math.random(),
      labelPosition: 'right',
      activeStep: '', // 当前选中的步骤
      openStepList: [],
      stepList: [],
      disAssembleyDiretionTypeOption: [
        {
          label: '前',
          value: 0,
          cloundValue: '0,-1,0',
        },
        {
          label: '后',
          value: 1,
          cloundValue: '0,1,0',
        },
        {
          label: '左',
          value: 2,
          cloundValue: '-1,0,0',
        },
        {
          label: '右',
          value: 3,
          cloundValue: '1,0,0',
        },
        {
          label: '上',
          value: 4,
          cloundValue: '0,0,1',
        },
        {
          label: '下',
          value: 5,
          cloundValue: '0,0,-1',
        },
      ],
      uploadExcelProps: {
        visible: false,
        title: '步骤列表导入模板.xlsx',
        excelType: 'stepList',
        schemeId: '',
      },
      conditionOption: [],
      stepFormRules: {},
      sortable: null,
    }
  },
  watch: {
    async loadSceneEnd(val) {
      if (val) {
        console.log('-----loadSceneEnd----')
        await this.setNodeListPosition(this.stepList, 'loadSceneEnd')
        // 当使用坐标轴工具完成一次编辑后通知
        this.player.Native.Node.EventAxisEditFinish.connect(this.nodeEditChanged)
      }
    },
    steps() {
      this.stepList = _.clone(this.steps)
      this.setSort()
      if (this.loadSceneEnd) {
        this.setNodeListPosition(this.stepList)
      }
    },
    async currentSelectModel(val) {
      if (val) {
        // 判断当前步骤列表中是否存在
        const nodeInfo = await this.player.Native.Node.getProperty(val, ['name', 'code'])
        const currentNode = _.find(this.stepList, ['nodeName', nodeInfo.name])
        if (currentNode && this.activeStep !== nodeInfo.name) {
          this.handleCollapseChange(currentNode)
          this.openStepList = [nodeInfo.name]
        } else {
          const currentEditNodeIndex = _.findIndex(this.stepList, ['id', this.currentEditNodeId])
          if (currentEditNodeIndex !== -1) {
            await this.player.Native.Node.removeNodeFromAxisEdit(
              this.stepList[currentEditNodeIndex].node
            )
            await this.player.Native.Node.setAxisEditType(0)
            this.currentEditNodeId = ''
          }
        }
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.stepList = _.clone(this.steps)
      this.setSort()
      if (this.loadSceneEnd) {
        console.log('-----loadSceneEnd----')
        this.setNodeListPosition(this.stepList)
      }
    })
    this.uploadExcelProps.schemeId = this.schemeId
  },
  methods: {
    async getSchemeDetail() {
      const [err, res] = await equipDisAssembleySolution.get(this.schemeId)
      if (!err && !_.isEmpty(res)) {
        this.stepList = _.map(res.steps, (el) => {
          return {
            ...el,
            targetLocation: el.targetLocation.split(','),
            srcLocation: el.srcLocation.split(','),
          }
        })
        this.setSort()
        this.setNodeListPosition(this.stepList)
      }
    },
    async setNodeListPosition(stepList, type) {
      const nodeNameList = _.map(stepList, (el) => {
        return el.nodeName
      })
      const root = await this.player.Native.Node.getRoot()
      const datas = await this.player.Native.Node.findNode(root, { names: nodeNameList })
      _.forEach(stepList, (el, index) => {
        el.node = (datas.names && datas.names[el.nodeName] && datas.names[el.nodeName].node) || ''
      })
      for (let i = 0; i < stepList.length; i = i + 1) {
        const element = stepList[i]
        await this.player.Native.Node.setProperty(element.node, {
          localTrans: element.targetLocation,
        })
      }
    },
    // 设置拖拽排序
    setSort() {
      this.sortable = null
      this.$nextTick(() => {
        const el = this.$refs.dragCollapse.$el
        this.sortable = Sortable.create(el, {
          ghostClass: 'sortable-ghost', // 放置占位符的类名
          handle: '.handle',
          setData: (dataTransfer) => {
            dataTransfer.setData('Text', '')
          },
          onEnd: (evt) => {
            // console.log('拖拽结束', evt)
            const temp = this.stepList.splice(evt.oldIndex, 1)[0] // splice该方法会改变原始数组，返回被删除的项目集合
            this.stepList.splice(evt.newIndex, 0, temp)
            this.dragKey = Math.random()
            this.setSort()
          },
          onStart: (evt) => {
            // console.log(evt, '拖拽开始')
            this.activeStep = ''
          },
        })
      })
    },
    operate(type) {
      if (type === 'collapse') {
        this.openStepList = []
        this.activeStep = ''
        this.cancelEdit()
      } else {
        this.openStepList = _.map(this.stepList, 'nodeName')
      }
    },
    handleCollapseChange(data) {
      console.log(this.openStepList, data, 'this.openStepList')
      if (
        _.find(this.openStepList, (el) => {
          return el === data.nodeName
        })
      ) {
        this.activeStep = ''
        this.cancelEdit()
        this.openStepList = _.filter(this.openStepList, (el) => {
          return el !== data.nodeName
        })
      } else {
        // 获取条件选项
        this.activeStep = data.nodeName
        this.conditionOption = _.filter(this.stepList, (el) => {
          return el.nodeName !== data.nodeName
        })
        // 设置节点为编辑状态
        const currentNode = _.find(this.stepList, (el) => {
          return el.nodeName === data.nodeName
        })
        this.setEditState(currentNode)
        this.openStepList = [data.nodeName]
      }
    },
    // 生成UUID
    getUUID() {
      const tempUrl = URL.createObjectURL(new Blob())
      const uuid = tempUrl.toString()
      URL.revokeObjectURL(tempUrl)
      return uuid.substring(uuid.lastIndexOf('/') + 1)
    },
    async addStep(currentId) {
      // 获取当前选中的节点
      const selectNode = await this.player.Native.Node.getSeletedNodes()
      console.log(selectNode, 'selectNode')
      if (!selectNode) {
        this.$message.warning('请先选择一个节点进行编辑')
        return
      }
      if (selectNode && !selectNode.length) {
        this.$message.warning('请选择一个模型进行编辑')
        return
      }
      const nodeInfo = await this.player.Native.Node.getProperty(selectNode[0], [
        'name',
        'code',
        'localTrans',
      ])
      const currentNode = _.find(this.stepList, ['nodeName', nodeInfo.name])
      console.log(currentNode, 'currentNode')
      if (_.isEmpty(currentNode)) {
        // 步骤列表中不存在,新增
        // const stepInfo = await this.player.Native.DisassembleAnsAssemble.addStep(selectNode.nodePtr)
        await this.player.Native.Node.addNodeToAxisEdit(selectNode[0])
        await this.player.Native.Node.setAxisEditType(1)
        const stepItem = {
          nodeName: nodeInfo.name,
          id: await this.getUUID(),
          name: nodeInfo.name,
          disAssembleyRemark: '',
          assembleyRemark: '',
          disAssembleyCondition: '',
          assembleyCondition: '',
          disAssembleyDiretionType: 3,
          moveDistance: 1,
          grade: '',
          targetLocation: nodeInfo.localTrans,
          srcLocation: nodeInfo.localTrans,
          speed: 1,
          node: selectNode[0],
        }
        const currentInsertIndex = _.findIndex(this.stepList, ['id', currentId])
        if (currentInsertIndex !== -1) {
          this.stepList.splice(currentInsertIndex, 0, { ...stepItem })
        } else {
          this.stepList.push({ ...stepItem })
        }
        this.currentEditNodeId = stepItem.id
        return
      }
      this.$message.warning('已在步骤列表中,不能重复添加！')
      this.activeStep = currentNode.id
    },
    // 计算两点的距离
    calcLength(a, b) {
      return Math.sqrt(
        (a[0] - b[0]) * (a[0] - b[0]) +
          (a[1] - b[1]) * (a[1] - b[1]) +
          (a[2] - b[2]) * (a[2] - b[2])
      )
    },
    async cancelEdit() {
      const preNode = _.find(this.stepList, ['id', this.currentEditNodeId])
      if (preNode) {
        await this.player.Native.Node.removeNodeFromAxisEdit(preNode.node)
      }
      this.currentEditNodeId = ''
      this.player.Native.Node.setAxisEditType(0)
      this.player.Native.Node.unSelectNodes(0)
    },
    // 移除步骤
    async deleteStep(nodeName) {
      const currentInsertIndex = _.findIndex(this.stepList, ['nodeName', nodeName])
      // 还原节点的位置
      if (currentInsertIndex !== -1) {
        const root = await this.player.Native.Node.getRoot()
        const node = await this.player.Native.Node.findNodeByName(
          root,
          this.stepList[currentInsertIndex].nodeName
        )
        console.log(node, 'node')
        await this.player.Native.Node.setProperty(node, {
          localTrans: this.stepList[currentInsertIndex].srcLocation,
        })
        // 清除步骤
        await this.player.Native.Node.removeNodeFromAxisEdit(node)
        this.cancelEdit()
      }
      const currentStep = this.stepList.splice(currentInsertIndex, 1)
      _.forEach(this.stepList, (el) => {
        el.disAssembleyCondition =
          currentStep.nodeName === el.disAssembleyCondition ? el.disAssembleyCondition : ''
        el.assembleyCondition =
          currentStep.nodeName === el.assembleyCondition ? el.assembleyCondition : ''
      })
      this.saveStep()
    },
    async stepOperate(type) {
      switch (type) {
        case 'add':
          this.addStep()
          break
        case 'insert':
          if (!this.activeStep) {
            this.$message.warning('请先选择一条步骤')
            return
          }
          this.addStep(this.activeStep)
          break
        case 'delete':
          if (!this.activeStep) {
            this.$message.warning('请先选择一条步骤')
            return
          }
          this.deleteStep(this.activeStep)
          break
        case 'save':
          this.activeStep = ''
          this.cancelEdit()
          this.saveStep()
          break
        case 'import':
          this.uploadExcelProps.visible = true
          // this.importStep()
          break
        case 'export':
          const [err, res] = await equipDisAssembleySolution.exportSteps(this.schemeId)
          // 返回的是文件流
          if (!err && res) {
            this.downLoadBlob({
              name: '步骤列表.xlsx',
              data: res,
            })
          }
          break
        default:
          break
      }
    },
    /**
     * @description: 设置节点的编辑状态
     * @param {*} editNode
     * @return {*}
     */

    async setEditState(editNode) {
      if (this.currentEditNodeId === editNode.id) return
      const preNode = _.find(this.stepList, ['id', this.currentEditNodeId])
      if (preNode) {
        await this.player.Native.Node.removeNodeFromAxisEdit(preNode.node)
      }
      await this.player.Native.Node.addNodeToAxisEdit(editNode.node)
      await this.player.Native.Node.setAxisEditType(1)
      this.currentEditNodeId = editNode.id
    },
    /**
     * @description: 节点被编辑后的事件
     * @param {*} node
     * @return {*}
     */

    async nodeEditChanged(node) {
      console.log(node, 'node')
      const position = await this.player.Native.Node.getProperty(node.node, ['localTrans'])
      const currentEditNodeIndex = _.findIndex(this.stepList, ['id', this.currentEditNodeId])
      if (currentEditNodeIndex !== -1) {
        const distance = this.calcLength(
          this.stepList[currentEditNodeIndex].srcLocation,
          position.localTrans
        )
        console.log(this.stepList[currentEditNodeIndex], distance, position, 'position============')
        this.stepList[currentEditNodeIndex].targetLocation = position.localTrans
      }
    },

    async saveStep() {
      const [err, res] = await equipDisAssembleySolution.addSteps(this.schemeId, {
        body: _.map(this.stepList, (el, index) => {
          return {
            solutionId: this.schemeId,
            nodeName: el.nodeName,
            seq: index,
            disAssembleyRemark: el.disAssembleyRemark,
            assembleyRemark: el.assembleyRemark,
            disAssembleyCondition: el.disAssembleyCondition,
            assembleyCondition: el.assembleyCondition,
            disAssembleyDiretionType: el.disAssembleyDiretionType,
            moveDistance: String(el.moveDistance),
            grade: el.grade,
            targetLocation: el.targetLocation.join(','),
            srcLocation: el.srcLocation.join(','),
            name: el.name,
            speed: el.speed,
          }
        }),
      })
      if (!err && res) {
        this.$message.success('成功')
      } else {
        this.$message.error(res.message)
      }
    },
  },
  async beforeDestroy() {
    // 弹出提示 保存步骤列表
    this.$confirm('是否需要保存当前的步骤列表', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(async () => {
        await this.saveStep()
      })
      .catch(() => {})
  },
}
</script>

<!-- <style lang="scss">
@import '../css/select';
</style> -->
<style lang="scss" scoped>
@import '../css/base';
@import '../css/index';
.step-list {
  right: 10px;
  top: 90px;
  height: calc(100% - 110px) !important;
  width: 400px;
  z-index: 100;
  padding: 10px;
  background-color: #2e6bb07f !important;
  &__header {
    height: 30px !important;
  }
  &__title {
    background-image: linear-gradient(180deg, #ffffff 51%, #5ab0ff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0px 3px 3px #00265f4c !important;
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    text-align: left;
    letter-spacing: 2px;
  }
  &__content {
    height: calc(100% - 120px) !important;
    width: 100%;
    background-color: #ffffff00 !important;
    border: none !important;
  }
}
::v-deep .el-card {
  background: #ffffff00 !important;
  overflow-y: auto;
  &__body {
    min-height: 100% !important;
    background: #18294866 !important;
  }
}
::v-deep.el-button--small {
  width: 80px !important;
}
::v-deep.el-button--primary {
  border-radius: 4px;
  background: #00c0ff !important;
}
::v-deep .el-collapse-item div[role='tab'] {
  border-radius: 4px;
  background-color: transparent;
}
::v-deep.el-collapse {
  border: none !important;
  .active-step__title {
    color: #00c0ff !important;
  }
  .el-collapse-item {
    .el-collapse-item__header {
      background-color: #ffffff00 !important;
      color: #d2e5ff !important;
      border: none !important;
    }
    .el-collapse-item__wrap {
      border-radius: 4px;
      background: #0d1b3766 !important;
      margin-right: 10px;
      margin-left: 10px;
      padding: 10px;
      border: none;
    }
    .el-collapse-item__arrow {
      display: none;
    }
    .el-collapse-item__content {
      padding-bottom: 0px;
    }
  }
}
::v-deep.el-form {
  background-color: #ffffff00 !important;
  &-item__label {
    color: #fff !important;
  }
}
::v-deep.el-input__inner,
::v-deep.el-textarea__inner {
  background: #0d1b3799 !important;
  border-radius: 4px;
  border: none !important;
  color: #ccedff !important;
  scrollbar-base-color: #00c0ff !important;
}
.sortable-ghost {
  opacity: 0.8;
  background: rgba(36, 118, 224, 0.1) !important;
}
::v-deep .training-dialog {
  .el-dialog__header {
    .el-dialog__close {
      color: #fff !important;
    }
  }
  .el-dialog__body {
    color: #fff !important;
    .el-step__main {
      .is-success {
        color: #0055ff !important;
      }
      .is-wait {
        color: #fff !important;
      }
    }
  }
}
</style>
